import axios from "axios";

import { TaskModel } from "@teamprevent/common/task/taskActions/models";
import { ServerModelWithDateStrings } from "@teamprevent/common/utils";

import { parseTaskModel } from "../task/model";

import {
    CreateGPSpecialistInfo,
    EditGPSpecialistInfo,
    GPSpecialistInfo,
    GPSpecialistLetterModel,
    SendLetterToGPSpecialistModel,
    WriteToGPSpecialistModel,
    parseGPSpecialistLetterModel
} from "./models";

const gpSpecialistInfoBaseUrl = "/api/generalPractitionerSpecialist";
const gpSpecialistLetterBaseUrl = "/api/generalPractitionerSpecialistLetter";

const create = async (customerId: string, employeeRecordId: string, createModel: CreateGPSpecialistInfo) => {
    return (await axios.post<GPSpecialistInfo>(`${gpSpecialistInfoBaseUrl}/${customerId}/${employeeRecordId}`, createModel)).data;
};

const edit = async (customerId: string, employeeRecordId: string, editModel: EditGPSpecialistInfo) => {
    return (await axios.put<GPSpecialistInfo>(`${gpSpecialistInfoBaseUrl}/${customerId}/${employeeRecordId}`, editModel)).data;
};

const get = async (customerId: string, employeeRecordId: string, id: string) => {
    return (await axios.get<GPSpecialistInfo>(`${gpSpecialistInfoBaseUrl}/${customerId}/${employeeRecordId}/${id}`)).data;
};

const getAll = async (customerId: string, employeeRecordId: string) => {
    return (await axios.get<GPSpecialistInfo[]>(`${gpSpecialistInfoBaseUrl}/${customerId}/${employeeRecordId}`)).data;
};

const deleteRecord = (customerId: string, employeeRecordId: string, id: string) => {
    return axios.delete(`${gpSpecialistInfoBaseUrl}/${customerId}/${employeeRecordId}/${id}`);
};

const writeToGPSpecialist = async (customerId: string, ohCaseId: string, taskId: string, model: WriteToGPSpecialistModel) => {
    const response = await axios.post<TaskModel[]>(`${gpSpecialistLetterBaseUrl}/${customerId}/${ohCaseId}/${taskId}/write`, model);
    return response.data.map(parseTaskModel);
};

const getGPSpecialistLetter = async (customerId: string, ohCaseId: string, taskId: string) => {
    const response = await axios.get<ServerModelWithDateStrings<GPSpecialistLetterModel>>(
        `${gpSpecialistLetterBaseUrl}/${customerId}/${ohCaseId}/${taskId}/letter`
    );
    return parseGPSpecialistLetterModel(response.data);
};

const sendLetterToGPSpecialist = async (customerId: string, ohCaseId: string, taskId: string, model: SendLetterToGPSpecialistModel) => {
    const response = await axios.post<TaskModel[]>(`${gpSpecialistLetterBaseUrl}/${customerId}/${ohCaseId}/${taskId}/sendLetter`, model);
    return response.data.map(parseTaskModel);
};

export const generalPractitionerSpecialistApi = {
    create,
    edit,
    get,
    getAll,
    deleteRecord,
    writeToGPSpecialist,
    getGPSpecialistLetter,
    sendLetterToGPSpecialist
};
